export default __webpack_public_path__ + "static/media/groc-shopping.96bf533d.svg";